import { createLibI18n, i18n } from '@w/react-i18n'

export const uiTranslations = {
  ui: {
    image: {
      unavailable: 'Image is unavailable',
      loading: 'Loading image',
      retry: 'Retry',
    },
    datePicker: {
      pickDate: 'Pick a date',
      clear: 'Clear',
    },
    fileUpload: {
      dropText: 'Drop files here or click to browse',
      selectButton: 'Select Files',
      maxSize: i18n`Max size: ${'size'}`,
      removeAll: 'Remove All',
      invalidFileType: i18n`File "${'fileName'}" is not an accepted file type.`,
    },
    fileInput: {
      dropFile: 'Drop file or click to select',
      dropFiles: 'Drop file(s) or click to select',
      dropImage: 'Drop image or click to select',
      dropImages: 'Drop image(s) or click to select',
      dropAudio: 'Drop audio or click to select',
      dropAudios: 'Drop audio(s) or click to select',
      dropVideo: 'Drop video or click to select',
      dropVideos: 'Drop video(s) or click to select',
      tapFile: 'Tap to select file',
      tapFiles: 'Tap to select file(s)',
      tapImage: 'Tap to select image',
      tapImages: 'Tap to select image(s)',
      tapAudio: 'Tap to select audio',
      tapAudios: 'Tap to select audio(s)',
      tapVideo: 'Tap to select video',
      tapVideos: 'Tap to select video(s)',
      dropHere: 'Drop it here',
      wrongType: 'Wrong file type',
      noYoutubeLink: 'No YouTube link in clipboard',
      uploadOnlyOne: 'Upload only one file',
      tooLarge: i18n`Too large (Max ${'size'})`,
      maxFiles: i18n`Max ${'count'} file(s)`,
      pasteClipboard: 'Paste from clipboard',
      pasteYoutube: 'Paste YouTube link',
      recordAudio: 'Record audio',
      stopRecording: i18n`Stop (${'seconds'}s)`,
      removeFile: 'Remove file',
      deleteFile: 'Delete file',
      removeYoutube: 'Remove YouTube',
      removeAll: 'Remove all',
      playAudio: 'Play audio',
      pauseAudio: 'Pause audio',
    },
    'platform:error': {
      details: 'Details',
      technicalDetails: 'Technical details',
      recoveryDescription: 'The app couldn’t finish loading. Reload to try again. If this keeps happening, copy the error details and share them with support.',
      reload: 'Reload app',
      copy: 'Copy details',
      copied: 'Copied',
      copySuccess: 'Error details copied. You can share them with support.',
      copyFailed: 'Couldn’t copy. Open technical details to select and copy the error.',
      storage: 'Storage error — reload the page.',
      generic: {
        title: 'Something went wrong',
        message: 'An error occurred',
        description:
          'Please try again or contact support if the problem persists.',
      },
    },
  },
} as const

export const uiI18n = createLibI18n({
  defaultTranslations: uiTranslations,
})

// oxlint-disable-next-line typescript/unbound-method -- Radix ref method; not an unbound method
export const { useTranslation, I18nProvider, useLocale } = uiI18n
export type UiTranslations = typeof uiTranslations
